import React, { useState } from "react";
import { Input } from "@/components/ui/input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with a show/hide eye toggle.
 * Forwards all extra props to the underlying <Input>.
 */
export default function PasswordInput({ value, onChange, testid, ...rest }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <Input
        value={value}
        onChange={onChange}
        type={visible ? "text" : "password"}
        data-testid={testid}
        className="pr-10 mt-1.5 bg-slate-50 border-slate-200 font-mono-fin"
        {...rest}
      />
      <button
        type="button"
        onClick={() => setVisible(v => !v)}
        className="absolute right-2 top-1/2 -translate-y-1/2 mt-[3px] p-1.5 rounded-md text-slate-500 hover:text-slate-800 hover:bg-slate-100"
        aria-label={visible ? "Hide password" : "Show password"}
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
      >
        {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
